import script from "./BCTmp.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCTmp.vue?vue&type=script&lang=ts&setup=true"

import "./BCTmp.vue?vue&type=style&index=0&id=65c07537&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c07537"]])

export default __exports__